import React from 'react';
import solution from "../../images/solutions.png";
const HeroSection = () => {
  return (
    <div 
      className=" w-full h-[599px] "
      style={{
        background: 'linear-gradient(119.39deg, #0D924F 31.98%, rgba(0, 174, 217, 0.3) 119.02%)'
      }}
    >
      {/* Text Content */}
      <div
        className="absolute text-white"
        style={{
          // width: '642px',
          height: '228px',
          left: '120px',
          top: 'calc(50% - 114.5px)',
          fontSize: '64px',
          lineHeight: '76px',
          fontWeight: 400
        }}
      >
        Fuel your impact with <br/> <span className="font-bold w-[642px]"> CloseCarbon's <br/> sustainability solution</span>
      </div>

      {/* Image */}
      <img loading='lazy' src={solution} alt="Solution Hero"
        className="absolute bg-cover bg-center bg-no-repeat w-[500px] left-[850px] top-[70px] "
  
      />
    </div>
  );
};

export default HeroSection;